import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiCheckCircle, FiXCircle } from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import LoadingContext from '../../contexts/LoadingContext';
import api from '../../service/api';
import Paginator from '../../components/Paginator';

import './styles.css';

interface ListaCliente {
  clienteId: string;
  codigo: string;
  identidade: {
    razaoSocial: string;
    nomeFantasia: string;
  }
  endereco: {
    municipio: string;
    uf: string;
  }
  dadosInternet: {
    email: string;
  }
  atendente: {
    responsavel: Responsavel;
  },
  responsavelEmpresa: {
    email: string;
  },
  criadoProd: boolean;
  criadoAmbTeste: boolean;
}

interface Responsavel {
  nome: string;
}

const CriarAmbiente: React.FC = () => {
  const { jwt, signOut } = useAuth();
  api.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.message === 'Request failed with status code 401') {
        signOut();
      } else {
        return error;
      }
    }
  );

  if (jwt) api.defaults.headers = { Authorization: `Bearer ${jwt}` };
  const [codigoBusca, setCodigoBusca] = useState('');
  const [palavraChave, setPalavraChave] = useState('');
  const { changeLoadingState } = useContext(LoadingContext);
  const [listaClientes, setListaClientes] = useState<ListaCliente[]>([]);

  // Paginação
  const [offset, setOffset] = useState(0);
  const [limit] = useState(9);
  const [total, setTotal] = useState(0);

  function onBuscaChange(e: React.ChangeEvent<HTMLInputElement>){
    const { value } = e.target;
    setCodigoBusca(value);
  };

  function onSubmit(e: React.FormEvent<HTMLFormElement>){
    e.preventDefault();
    setPalavraChave(codigoBusca);
    setOffset(0);
  }

  const getListaClientes = useCallback(
    async () => {
      if(palavraChave.length < 1) return;
      changeLoadingState(true);
      try {
        const resposta = await api.get(
          `/listar-clientes?limit=${limit}&offset=${offset}&palavraChave=${palavraChave}`
        );
        setTotal(resposta.data.total);
        setListaClientes(
          resposta.data && resposta.data.total > 0 ? resposta.data.clientes : []
        );
        changeLoadingState(false);
      } catch (e) {
        console.log(e);
        changeLoadingState(false);
      }
    },
    // eslint-disable-next-line
    [offset, limit, palavraChave]
  );

  useEffect(() => {getListaClientes()},[getListaClientes]);

  const showPaginator = useMemo(() => {
    return total > limit;
  },[total,limit])

  return (
    <div className='container'>
      <form className='busca-container' onSubmit={e => onSubmit(e)}>
        <div>
          <label htmlFor='busca-codigo'>
            Buscar por código ou palavra chave
          </label>
          <br />
          <input
            type='text'
            id='busca-codigo'
            value={codigoBusca}
            onChange={e => onBuscaChange(e)}
          />
        </div>
        <button type='submit' className='submit-busca-cliente'>
          Buscar
        </button>
      </form>

      <div className='container-cards'>
        {listaClientes.length > 0 ? (
          listaClientes.map((cliente: any) => {
            return (
              <div key={cliente.clienteId} className='card-cliente'>
                <p>
                  <b>Código:</b> {cliente.codigo}
                </p>
                <p>
                  <b>Razão Social:</b> {cliente.identidade.razaoSocial}
                </p>
                <p>
                  <b>Nome Fantasia:</b> {cliente.identidade.nomeFantasia}
                </p>
                <p>
                  <b>Cidade:</b>{' '}
                  {`${cliente.endereco.municipio}/${cliente.endereco.uf}`}
                </p>
                <p>
                  <b>E-mail:</b> {cliente.dadosInternet.email}
                </p>
                <p>
                  <b>Atendente:</b> {cliente.atendente.responsavel.nome}
                </p>
                <p>
                  <b>E-mail responsável:</b> {cliente.responsavelEmpresa.email}
                </p>
                <div className='card-cliente-acoes'>
                  <div className='cliente-acoes-container'>
                    <strong>Produção</strong>
                    {cliente.criadoProd ? (
                      <FiCheckCircle size={20} color='#009688' />
                    ) : (
                      <>
                        <FiXCircle size={20} color='#975353' />
                        <Link
                          to={`/revisar-dados/${cliente.clienteId}/PROD`}
                          className='cliente-criar-btn'
                        >
                          Criar
                        </Link>
                      </>
                    )}
                  </div>
                  <div className='cliente-acoes-container'>
                    <strong>Ambiente de teste</strong>
                    {cliente.criadoAmbTeste ? (
                      <FiCheckCircle size={20} color='#009688' />
                    ) : (
                      <>
                        <FiXCircle size={20} color='#975353' />
                        <Link
                          to={`/revisar-dados/${cliente.clienteId}/AMBIENTE_TESTE`}
                          className='cliente-criar-btn'
                        >
                          Criar
                        </Link>
                      </>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p>Nenhum cliente encontrado.</p>
        )}
      </div>
      {showPaginator && 
        <Paginator 
          total={total}
          limit={limit}
          offset={offset}
          setOffset={setOffset}
        />}
    </div>
  );
};

export default CriarAmbiente;
